import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import PlatformSettings from "../components/PlatformSettings";
import Divider from "@mui/material/Divider";
import ProfileInfoCard from "../../../examples/Cards/InfoCards/ProfileInfoCard";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import ProfilesList from "../../../examples/Lists/ProfilesList";
import profilesListData from "../data/profilesListData";
import React, {useEffect, useState} from "react";
import Configurator from "../../../examples/Configurator";
import LocalStorage from "../../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {getUserSetting} from "../../../actions";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

const UserInfo = () =>{

    const [userInfo,setUserInfo] = useState({})
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const onGetUserInfoSuccess = (data) =>{
        setUserInfo(data.data?.userInfo)
        // getAvatarUrl()
    }
    const getUserInfoFetch = ()=>{
        dispatch(getUserSetting(onGetUserInfoSuccess))
    }

    useEffect(() => {
        getUserInfoFetch()
    }, [])

    return (
        <div>
            <MDBox mb={3}>
                <Grid container spacing={1}>

                    {
                        checkPermission(PERMISSION_DICT.AccountDataList) &&
                        <Grid item xs={12} lg={4} xl={4} sx={{ display: "flex" }}>
                            <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                            <ProfileInfoCard
                                title={t("AccountPage.profile information")}
                                description=""
                                userInfo={userInfo}
                                info={{
                                    ownerID: `${userInfo?.ownerId}`,
                                    userName: `${userInfo?.userName}`,
                                    mobile: `${userInfo?.phone}`,
                                    email: `${userInfo?.email}`,
                                    location: `${userInfo?.city}, ${userInfo?.province}, ${userInfo?.country}`,
                                    address: `${userInfo?.address1}`,
                                }}
                                social={[
                                    {
                                        // link: "https://www.facebook.com/CreativeTim/",
                                        icon: <FacebookIcon />,
                                        color: "facebook",
                                    },
                                    {
                                        // link: "https://twitter.com/creativetim",
                                        icon: <TwitterIcon />,
                                        color: "twitter",
                                    },
                                    {
                                        // link: "https://www.instagram.com/creativetimofficial/",
                                        icon    : <InstagramIcon />,
                                        color: "instagram",
                                    },
                                ]}
                                action={{ route: "", tooltip: t("AccountPage.Profile Detail")}}
                                shadow={false}
                                getUserInfoFetch={getUserInfoFetch}
                            />
                            <Divider orientation="vertical" sx={{ mx: 0 }} />
                        </Grid>
                    }

                    {/*{role === 'customer' &&*/}
                    {/*    <Grid item xs={12} lg={6} xl={6}>*/}
                    {/*        <PlatformSettings />*/}
                    {/*    </Grid>*/}
                    {/*}*/}

                    {/*<Grid item xs={12} lg={6} xl={4}>*/}
                    {/*    <ProfilesList title="conversations" profiles={profilesListData} shadow={false}/>*/}
                    {/*</Grid>*/}

                    <Configurator/>
                </Grid>
            </MDBox>
        </div>
    )
}

export default UserInfo